import './about.css'
import { useSelector } from "react-redux";
import ar from "../../util/locales/ar";
import en from "../../util/locales/en";

const HeroSection = () => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;
  return (
    <div className="about-hero">
      <img src="/imgs/about-car.png" alt="about-car" />
      <div>
        <h1>{t.about.hero.title}</h1>
        <p>{t.about.hero.text}</p>
      </div>
    </div>
  );
};

export default HeroSection;
